import PropTypes from 'prop-types'
import classNames from 'classnames'
import React, { PureComponent } from 'react'

export default class Icon extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    name: PropTypes.string.isRequired
  }

  render() {
    const { name, className, ...rest } = this.props
    const classes = classNames(`im-icon-${name}`, className)

    return <i className={classes} {...rest} />
  }
}



// WEBPACK FOOTER //
// ../src/components/Icon.js